"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _membershipPermissions = _interopRequireDefault(require("./membership-permissions"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _ref = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", null, "Paddle UK Memberships and Credentials"), /*#__PURE__*/_react.default.createElement("div", {
  className: "card"
}, /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, /*#__PURE__*/_react.default.createElement("h3", null, "Membership Permissions for Entry Level")), /*#__PURE__*/_react.default.createElement("div", {
  className: "card-block"
}, /*#__PURE__*/_react.default.createElement(_membershipPermissions.default, null))), /*#__PURE__*/_react.default.createElement("br", null));
class PaddleUkMembership extends _react.Component {
  render() {
    return _ref;
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = PaddleUkMembership;